import { shopManagerApi } from 'configs';
import api from 'configs/api';

import {
  getSubscriptionSetupStart,
  getSubscriptionSetupSuccess,
  getSubscriptionSetupFailed,
  updateSubscriptionSetupStart,
  updateSubscriptionSetupSuccess,
  updateSubscriptionSetupFailed,
  getAdditionalSkusStart,
  getAdditionalSkusSuccess,
  getAdditionalSkusFailed,
  getAdditionalFeaturesStart,
  getAdditionalFeaturesSuccess,
  getAdditionalFeaturesFailed,
  getAdditionalSpecialsStart,
  getAdditionalSpecialsSuccess,
  getAdditionalSpecialsFailed,
  editAdditionalSkusStart,
  editAdditionalSkusSuccess,
  editAdditionalSkusFailed,
  editAdditionalFeaturesStart,
  editAdditionalFeaturesSuccess,
  editAdditionalFeaturesFailed,
  editAdditionalSpecialsStart,
  editAdditionalSpecialsSuccess,
  editAdditionalSpecialsFailed,
  createAdditionalSkusStart,
  createAdditionalSkusSucces,
  createAdditionalSkusFailed,
  createAdditionalFeaturesStart,
  createAdditionalFeaturesSuccess,
  createAdditionalFeaturesFailed,
  createAdditionalSpecialsStart,
  createAdditionalSpecialsSuccess,
  createAdditionalSpecialsFailed,
  deleteAdditionalSkusStart,
  deleteAdditionalSkusSuccess,
  deleteAdditionalSkusFailed,
  deleteAdditionalSpecialsStart,
  deleteAdditionalSpecialsSuccess,
  deleteAdditionalSpecialsFailed,
  deleteAdditionalFeaturesStart,
  deleteAdditionalFeaturesSuccess,
  deleteAdditionalFeaturesFailed,
  createMarketingBillingSuccess,
  createMarketingBillingFailed,
  createMarketingBillingStart,
  saveMarketingDataStart,
  saveMarketingDataFailed,
  saveMarketingDataSuccess,
  saveOnboardingDataStart,
  saveOnboardingDataFailed,
  saveOnboardingDataSuccess,
  billStoreFromOnboardingStart,
  billStoreFromOnboardingFailed,
  billStoreFromOnboardingSuccess,
  getSubscriptionBenefitsStart,
  getSubscriptionBenefitsFailed,
  getSubscriptionBenefitsSuccess,
  createSubscriptionBenefitStart,
  createSubscriptionBenefitFailed,
  createSubscriptionBenefitSuccess,
  updateSubscriptionBenefitStart,
  updateSubscriptionBenefitFailed,
  updateSubscriptionBenefitSuccess,
  deleteSubscriptionBenefitStart,
  deleteSubscriptionBenefitFailed,
  deleteSubscriptionBenefitSuccess
} from 'redux/actions/subscription';


export const getSubscriptionSetupApi = async ({dispatch}) => {
  try {
    dispatch(getSubscriptionSetupStart());
    const {data} = await api.get(`${shopManagerApi}/subscription/setup`);
    dispatch(getSubscriptionSetupSuccess(data));
  } catch (e) {
    dispatch(getSubscriptionSetupFailed(e));
  }
};

export const updateSubscriptionSetupApi = async ({dispatch, setupData}) => {
  try {
    dispatch(updateSubscriptionSetupStart());
    const {data} = await api.patch(`${shopManagerApi}/subscription/setup`, setupData);
    dispatch(updateSubscriptionSetupSuccess(data));
  } catch (e) {
    dispatch(updateSubscriptionSetupFailed(e));
  }
};

export const getAdditionalSkusApi = async ({dispatch}) => {
  try {
    dispatch(getAdditionalSkusStart());
    const { data } = await api.get(`${shopManagerApi}/subscription/additional/skus`);
    dispatch(getAdditionalSkusSuccess(data));
  } catch (e) {
    dispatch(getAdditionalSkusFailed(e));
  }
};

export const getAdditionalFeaturesApi = async ({dispatch}) => {
  try {
    dispatch(getAdditionalFeaturesStart());
    const { data } = await api.get(`${shopManagerApi}/subscription/additional/features`);
    dispatch(getAdditionalFeaturesSuccess(data));
  } catch (e) {
    dispatch(getAdditionalFeaturesFailed(e));
  }
};

export const getAdditionalSpecialsApi = async ({dispatch}) => {
  try {
    dispatch(getAdditionalSpecialsStart());
    const { data } = await api.get(`${shopManagerApi}/subscription/additional/specials`);
    dispatch(getAdditionalSpecialsSuccess(data));
  } catch (e) {
    dispatch(getAdditionalSpecialsFailed(e));
  }
};

export const editAdditionalSkusApi = async ({dispatch, skuId, sku}) => {
  try {
    dispatch(editAdditionalSkusStart());
    const { data } = await api.patch(`${shopManagerApi}/subscription/additional/skus/${skuId}`, sku);
    dispatch(editAdditionalSkusSuccess(data));
  } catch (e) {
    dispatch(editAdditionalSkusFailed(e));
  }
};

export const editAdditionalFeaturesApi = async ({dispatch, featureId, feature}) => {
  try {
    dispatch(editAdditionalFeaturesStart());
    const { data } = await api.patch(`${shopManagerApi}/subscription/additional/features/${featureId}`, feature);
    dispatch(editAdditionalFeaturesSuccess(data));
  } catch (e) {
    dispatch(editAdditionalFeaturesFailed(e));
  }
};

export const editAdditionalSpecialsApi = async ({dispatch, specialId, special}) => {
  try {
    dispatch(editAdditionalSpecialsStart());
    const { data } = await api.patch(`${shopManagerApi}/subscription/additional/specials/${specialId}`, special);
    dispatch(editAdditionalSpecialsSuccess(data));
  } catch (e) {
    dispatch(editAdditionalSpecialsFailed(e));
  }
};

export const createAdditionalSkusApi = async ({dispatch, sku}) => {
  try {
    dispatch(createAdditionalSkusStart());
    const { data } = await api.post(`${shopManagerApi}/subscription/additional/skus`, sku);
    dispatch(createAdditionalSkusSucces(data));
  } catch (e) {
    dispatch(createAdditionalSkusFailed(e));
  }
};

export const createAdditionalFeaturesApi = async ({dispatch, feature}) => {
  try {
    dispatch(createAdditionalFeaturesStart());
    const { data } = await api.post(`${shopManagerApi}/subscription/additional/features`, feature);
    dispatch(createAdditionalFeaturesSuccess(data));
  } catch (e) {
    dispatch(createAdditionalFeaturesFailed(e));
  }
};

export const createAdditionalSpecialsApi = async ({dispatch, special}) => {
  try {
    dispatch(createAdditionalSpecialsStart());
    const { data } = await api.post(`${shopManagerApi}/subscription/additional/specials`, special);
    dispatch(createAdditionalSpecialsSuccess(data));
  } catch (e) {
    dispatch(createAdditionalSpecialsFailed(e));
  }
};

export const deleteAdditionalSkusApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteAdditionalSkusStart());
    await api.delete(`${shopManagerApi}/subscription/additional/skus/${id}`);
    dispatch(deleteAdditionalSkusSuccess(id));
  } catch (e) {
    dispatch(deleteAdditionalSkusFailed(e));
  }
};

export const deleteAdditionalFeaturesApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteAdditionalFeaturesStart());
    await api.delete(`${shopManagerApi}/subscription/additional/features/${id}`);
    dispatch(deleteAdditionalFeaturesSuccess(id));
  } catch (e) {
    dispatch(deleteAdditionalFeaturesFailed(e));
  }
};

export const deleteAdditionalSpecialsApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteAdditionalSpecialsStart());
    await api.delete(`${shopManagerApi}/subscription/additional/specials/${id}`);
    dispatch(deleteAdditionalSpecialsSuccess(id));
  } catch (e) {
    dispatch(deleteAdditionalSpecialsFailed(e));
  }
};

export const saveUserOnboardingDataApi = async ({dispatch, setupData}) => {
  try {
    dispatch(saveOnboardingDataStart());
    const {data} = await api.patch(`${shopManagerApi}/onboarding`, setupData);
    dispatch(saveOnboardingDataSuccess(data));
    return true;
  } catch (e) {
    dispatch(saveOnboardingDataFailed(e));
    return false;
  }
};

export const billStoreFromOnboardingApi = async ({dispatch, billData}) => {
  try {
    dispatch(billStoreFromOnboardingStart());
    const {data} = await api.post(`${shopManagerApi}/customer/bill-from-onboarding`, billData);
    dispatch(billStoreFromOnboardingSuccess(data));
  } catch (e) {
    dispatch(billStoreFromOnboardingFailed(e));
  }
};

export const createMarketingBill = async ({dispatch}) => {
  try {
    dispatch(createMarketingBillingStart());
    const { data } = await api.post(`${shopManagerApi}/customer/bill-from-marketing`);
    dispatch(createMarketingBillingSuccess(data));

    return true;
  } catch (e) {
    dispatch(createMarketingBillingFailed(e));

    return false;
  }
};

// TODO: looks like we can use user profile instead of this
export const saveMarketingDataApi = async ({dispatch, marketingSummary}) => {
  try {
    dispatch(saveMarketingDataStart());
    const { data } = await api.post(`${shopManagerApi}/marketing`, marketingSummary);
    dispatch(saveMarketingDataSuccess(data));

    return true;
  } catch (e) {
    dispatch(saveMarketingDataFailed(e));

    return false;
  }
};

export const getSubscriptionBenefitsApi = async ({dispatch}) => {
  try {
    dispatch(getSubscriptionBenefitsStart());
    const { data } = await api.get(`${shopManagerApi}/subscription/benefits`);
    dispatch(getSubscriptionBenefitsSuccess(data));
  } catch (e) {
    dispatch(getSubscriptionBenefitsFailed(e));
  }
};

export const createSubscriptionBenefitApi = async ({dispatch, item}) => {
  try {
    dispatch(createSubscriptionBenefitStart());
    const { data } = await api.post(`${shopManagerApi}/subscription/benefits`, item);
    dispatch(createSubscriptionBenefitSuccess(data));
  } catch (e) {
    dispatch(createSubscriptionBenefitFailed(e));
  }
};

export const updateSubscriptionBenefitApi = async ({dispatch, item}) => {
  try {
    dispatch(updateSubscriptionBenefitStart());
    const { data } = await api.patch(`${shopManagerApi}/subscription/benefits/${item._id}`, item);
    dispatch(updateSubscriptionBenefitSuccess(data));
  } catch (e) {
    dispatch(updateSubscriptionBenefitFailed(e));
  }
};

export const deleteSubscriptionBenefitApi = async ({dispatch, item}) => {
  try {
    dispatch(deleteSubscriptionBenefitStart());
    const { data } = await api.delete(`${shopManagerApi}/subscription/benefits/${item._id}`);
    dispatch(deleteSubscriptionBenefitSuccess(item, data));
  } catch (e) {
    dispatch(deleteSubscriptionBenefitFailed(e));
  }
};
